import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import Network from "../../utils/Network";
import { Urls } from "../../utils/Constants";
import Loader from "../common/Loader";
import ConfirmBbps from "../common/modal/confirmbbps";
import ErrorSuccessModal from "../common/modal/errorsuccessmodal";

export default function BbpsOnline() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("Electricity");
  const [billers, setBillers] = useState([]);
  const [selectedBiller, setSelectedBiller] = useState("");
  const [paraName, setParaName] = useState([]);
  const [paraCount, setParaCount] = useState("");
  const [inputValues, setInputValues] = useState([]);
  const [showConfirmPopUp, setShowConfirmPopUp] = useState(0);
  const [selectedBillerName, setSelectedBillerName] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [billDate, setBillDate] = useState("");
  const [billAmount, setBillAmount] = useState("");
  const [refId, setRefId] = useState("");
  const [amountDetails, setAmountDetails] = useState("");
  const [additionalParams, setAdditionalParams] = useState("");
  // const [billData, setBillData] = useState("");
  const [isErrorFlag, setIsErrorFlag] = useState(0);
  const [showErrorSuccessModal, setShowErrorSuccessModal] = useState(0);
  const [modalMsg, setModalMsg] = useState("");

  const openConfirmModal = () => setShowConfirmPopUp(1);
  const closeConfirmModal = () => setShowConfirmPopUp(0);

  const openModal = (type) => {
    switch(type){
      case 'Error':
        setIsErrorFlag(1);
        setShowErrorSuccessModal(1);
      break;
      case 'Success':
        setIsErrorFlag(0);
        setShowErrorSuccessModal(1);
      break;
    }    
  };
  const closeModal = (type) => {
    if(type === 'Success' || type === 'Error'){
      setIsErrorFlag(0);
      setShowErrorSuccessModal(0);
    }
  };

  const handleChange = (item, key, event) => {
    setInputValues({
      ...inputValues,
      [item.paramName] : event.target.value,
    });
  };


  useEffect(()=>{
    getBillers();
  },[selectedCategory])
  
  const getBillers = async () => {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("category", selectedCategory);
      try {
        setLoading(true);
        const response = await Network.post(Urls.baseUrlPostLogin + '/bbps-billers', formData);
        if(response?.data?.length >= 0){
          const options = response.data.map(item => ({
                value: item.billerId,
                label: item.billerName
            }));
            setBillers(options);
        }
      } catch (err) {
        console.log('error', err);
      } finally {
        setLoading(false); // Hide loader
      }
  }
  const selectedBillerId = (option) => {
    //const selectedOption = selectedElement.current.options[selectedElement.current.selectedIndex];
    setSelectedBillerName(option.label);
    setSelectedBiller(option.value);
  }
  useEffect(()=>{
    if(selectedBiller != ''){
      getBillerInfo();
    }
  },[selectedBiller])
  const getBillerInfo = async() => {
    console.log(selectedBiller);
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("billerId", selectedBiller);
      try {
        const response = await Network.post(Urls.baseUrlPostLogin + '/bbps-biller-info', formData);
        if(response?.data?.status === 0){
            setInputValues([]);
            setParaName(response.data.para);
            setParaCount(response.data.paracount);
        }
      } catch (err) {
        console.log('error', err);
      }
  }
  const billFetch = async() => {
    const newErrors = errorHandling('billFetch');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let formData = new FormData();
      const localStorageDataStr = localStorage.getItem('token');
      const item = JSON.parse(localStorageDataStr);
      formData.append("api_token", item.token);
      formData.append("billerId", selectedBiller);
      formData.append("pcount", paraCount);
      const entriesArray = Object.entries(inputValues); //convert object to array

        if(paraCount == 0){
          formData.append("paraname", entriesArray[0][0]);
          formData.append("paravalue", entriesArray[0][1]);
        }else if(paraCount == 2){
          formData.append("paraname", entriesArray[0][0]);
          formData.append("paravalue", entriesArray[0][1]);
          formData.append("paraname1", entriesArray[1][0]);
          formData.append("paravalue1", entriesArray[1][1]);
        }else if(paraCount == 3){
          formData.append("paraname", entriesArray[0][0]);
          formData.append("paravalue", entriesArray[0][1]);
          formData.append("paraname1", entriesArray[1][0]);
          formData.append("paravalue1", entriesArray[1][1]);
          formData.append("paraname2", entriesArray[2][0]);
          formData.append("paravalue2", entriesArray[2][1]);
        }
          try {
            const response = await Network.post(Urls.baseUrlPostLogin + '/bbps-bill-fetch', formData);
            if(response?.data?.status === 0){
              setAccountHolderName(response.data.accountHolderName);
              setDueDate(response.data.dueDate);
              setBillDate(response.data.billDate);
              setBillAmount(response.data.amount);
              setRefId(response.data.refId);
              setAmountDetails(response.data.amountDetails);
              setAdditionalParams(response.data.additionalParams);
              // setBillData(response?.data?.bill_data);//not receiving
              openConfirmModal();
            }else{
              const apiErrors = {apiError : response.data.message};
              setErrors(apiErrors);
            }
          } catch (err) {
            console.log('error', err);
          }
    }
  }
  const billPayment = async(amount,mpin) => {
    const newErrors = errorHandling('billPayment');
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
        const mtime = new Date().getTime();
        let formData = new FormData();
        const localStorageDataStr = localStorage.getItem('token');
        const item = JSON.parse(localStorageDataStr);
        formData.append("api_token", item.token);
        formData.append("mtime", mtime);
        formData.append("mpin", 1234);
        formData.append("billerId", selectedBiller);
        formData.append("amount", amount);
        formData.append("refId", refId);
        formData.append("accountHolderName", accountHolderName);
        formData.append("amountDetails", amountDetails);
        formData.append("additionalParams", additionalParams);
        formData.append("dueDate", dueDate);
        formData.append("billDate", billDate);
        // formData.append("bill_data", billData);//not receiving in bill fetch api
        formData.append("pcount", paraCount);
        const entriesArray = Object.entries(inputValues); //convert object to array

        if(paraCount == 0){
          formData.append("paraname", entriesArray[0][0]);
          formData.append("paravalue", entriesArray[0][1]);
        }else if(paraCount == 2){
          formData.append("paraname", entriesArray[0][0]);
          formData.append("paravalue", entriesArray[0][1]);
          formData.append("paraname1", entriesArray[1][0]);
          formData.append("paravalue1", entriesArray[1][1]);
        }else if(paraCount == 3){
          formData.append("paraname", entriesArray[0][0]);
          formData.append("paravalue", entriesArray[0][1]);
          formData.append("paraname1", entriesArray[1][0]);
          formData.append("paravalue1", entriesArray[1][1]);
          formData.append("paraname2", entriesArray[2][0]);
          formData.append("paravalue2", entriesArray[2][1]);
        }
        try {
            setLoading(true);
            const response = await Network.post(Urls.baseUrlPostLogin + '/bbps-pay-now', formData);
            if(response?.data?.status === 0){
              closeConfirmModal();
              setModalMsg(response.data.message);
              openModal('Success');
            }else{
              const apiErrors = {apiError : response.data.message};
              setErrors(apiErrors);
            }
          } catch (err) {
            console.log('error', err);
          } finally {
            setLoading(false); // Hide loader
          }

    }
  }
  const errorHandling = (type) => {
    const errors = {};
    if (type === 'billFetch') {
      if (!selectedBiller) {
        errors.selectedBiller = 'Biller name is required';
      }else if(paraCount === ""){
        errors.apiError = 'Data not fetched, please try again';
      }else if(inputValues.length === 0){
        errors.inputValues = 'please fill all the fields';
      }
      const entries = Object.entries(inputValues); // converts object to array of [key, value] pairs
      if(paraCount == 0){
        if(entries[0] != undefined){
          const [key, value] = entries[0];
            if (value === null || value === undefined || value.toString().trim() === '') {
              errors.inputValues = (`${key} is required`);
            }
        }else{
          errors.inputValues = 'Please fill all the required fields';
        }
      }else{
        for (let i = 0; i < paraCount; i++) {
          if(entries[i] != undefined){
            const [key, value] = entries[i];
            if (value === null || value === undefined || value.toString().trim() === '') {
              errors.inputValues = (`${key} is required`);
            }
          }else{
            errors.inputValues = 'Please fill all the required fields';
          }
        }
      }
    }
    return errors;
  };

  return (
    <>
      <Header />
      <div className="adminuiux-wrap">
        <Sidebar />
        {loading ?
        <Loader/> :
        <main
          className="adminuiux-content has-sidebar"
        >
          {/*mt-4*/}
          <div className="container " id="main-content">
            <div className="row align-items-center">
            </div>
            {/* dashboard inner */}
            <div className="midde_cont">
              <div className="container-fluid">
                <div className="row column_title">
                  <div className="col-md-12">
                    <div className="page_title d-sm-flex">
                      <h3>Bbps Online</h3>
                    </div>
                  </div>
                </div>
                <div className="row match-height" data-select2-id="select2-data-109-53pe">
                  <div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-12 mg-t-20">
                    <div className="form-group">
                      <label htmlFor="first-name-vertical">Service</label>
                      <select
                        className="form-control"
                        name="forma"
                        onChange={(e) => { setSelectedCategory(e.target.value) }}
                      >
                        <option value="Electricity" selected="">Electricity</option>
                        <option value="Water">Water</option>
                        <option value="Gas">Gas</option>
                        <option value="Lpg">Lpg</option>
                        <option value="Emi">EMI</option>
                        <option value="Insurance">Insurance</option>
                        <option value="Municipality">Municipality</option>
                        <option value="Cable">Cable</option>
                        <option value="Broadband postpaid">Broadband Postpaid</option>
                        <option value="Datacard prepaid">Datacard Prepaid</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-7 mg-t-20" />
                  <div className="col-md-5 col-12">
                    <div className="card">
                      <div className="card-content">
                        <div className="card-body">
                          <div className="form-body">
                            <div className="row">
                              <div
                                className="col-12 mg-t-20"
                                data-select2-id="select2-data-102-uh6h"
                              >
                                <div
                                  className="form-group"
                                  data-select2-id="select2-data-101-ihm3"
                                >
                                  <label htmlFor="first-name-vertical">Biller Name</label>
                                  <Select className="custom-dropdown" onChange={selectedBillerId} options={billers}/>
                                </div>
                                {errors.selectedBiller && (
                                  <span className="error-message">
                                    {errors.selectedBiller}
                                  </span>
                                )}
                              </div>
                              <div className="col-12" id="form-data">
                                {paraName.map((item,key) => (
                                   <div className="form-group">
                                    <label htmlFor="contact-info-vertical">{item.paramName}</label>
                                    <input type="text" className="form-control" value={inputValues[key]}
                                    onChange={(e) => handleChange(item,key, e)}/>
                                    </div>
                                ))}
                              </div>                              
                              {errors.apiError && (
                                  <span className="error-message">
                                    {errors.apiError}
                                  </span>
                              )}
                              {errors.inputValues && (
                                  <span className="error-message">
                                    {errors.inputValues}
                                  </span>
                              )}
                              <div className="col-12">
                                <button
                                  id="fetch_btn"
                                  className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                  onClick={billFetch}
                                >
                                  Fetch Bill
                                </button>
                              </div>
                              <div className="col-12" style={{ display: "none" }}>
                                <button
                                  id="quick_pay"
                                  className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                  onclick="paynow()"
                                >
                                  Quick Pay
                                </button>
                              </div>
                              <div className="col-12">
                                <button
                                  style={{ display: "none" }}
                                  id="pay_btn"
                                  className="btn btn-primary btn-sm tx-13 mr-1 mb-1 waves-effect waves-light"
                                  onclick="paynow()"
                                >
                                  Pay Now
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Modal */}
            {showConfirmPopUp === 1 &&
            <ConfirmBbps
                title="Bill Fetch"
                selectedBillerName={selectedBillerName}
                accountHolderName={accountHolderName}
                dueDate={dueDate}
                billDate={billDate}
                billAmount={billAmount}
                closeModal={closeConfirmModal}
                billPayment={billPayment}
                isBbps="1"
            />
            }
            {showErrorSuccessModal === 1 &&
                <ErrorSuccessModal
                  title={isErrorFlag === 0 ? 'Success' : 'Error'}
                  msg={modalMsg}
                  closeModal={closeModal}
                />
              }
            {/*end*/}
          </div>
        </main>
        }
      </div>
    </>
  );
}